import { onError } from '@apollo/client/link/error';

import { useThrottleToastState } from '@pflegia/ui/shared/hooks/use-throttle-toast';

export const THROTTLE_ERROR_MESSAGE = 'ThrottlerException: Too Many Requests';

// eslint-disable-next-line eslint-compat/naming-convention
const throttleLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors?.some(error => error.message === THROTTLE_ERROR_MESSAGE)) {
    useThrottleToastState.getState().showThrottleToast();
  }
});

export default throttleLink;
